import { Authenticator } from '@aws-amplify/ui-react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { RequireAuth } from './components/RequireAuth'
import { ConfigProvider } from 'antd'

import { CharactersPage } from './pages/Characters'
import { AdventuresPage } from './pages/Adventures'
import { LandingPage } from './pages/Landing'
import { LoginPage } from './pages/LoginPage'
import { HomePage } from './pages/HomePage'
import { AdventureDetailsPage } from './pages/AdventureDetails'
import { CharacterDetailsPage } from './pages/CharacterDetails'

import { Amplify } from 'aws-amplify'
import awsExports from './aws-exports'
import { Header } from './components/Header'
import { CreateCharacterPage } from './pages/CreateCharacter'
Amplify.configure(awsExports)

const MyRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" index element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<Header />}>
          <Route
            path="/home"
            element={
              <RequireAuth>
                <HomePage />
              </RequireAuth>
            }
          />
          <Route
            path="/character"
            element={
              <RequireAuth>
                <CharactersPage />
              </RequireAuth>
            }
          />
          <Route
            path="/character/:id"
            element={
              <RequireAuth>
                <CharacterDetailsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/character/create"
            element={
              <RequireAuth>
                <CreateCharacterPage />
              </RequireAuth>
            }
          />
          <Route
            path="/adventure"
            element={
              <RequireAuth>
                <AdventuresPage />
              </RequireAuth>
            }
          />
          <Route
            path="/adventure/:id"
            element={
              <RequireAuth>
                <AdventureDetailsPage />
              </RequireAuth>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export const App = () => {
  return (
    <ConfigProvider theme={{ token: { colorPrimary: 'black' } }}>
      <Authenticator.Provider>
        <MyRoutes />
      </Authenticator.Provider>
    </ConfigProvider>
  )
}
